import React from 'react';

import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contactus from './components/pages/Contactus';

import Aboutpage from './components/pages/Aboutpage';
import Projectpage from './components/pages/Projectpage';
import Productpage from './components/pages/Productpage';
import Cctv from './components/pages/Cctv';
import Gps from './components/pages/Gps';
import Intercom from './components/pages/Intercom';
import ComputerCare from './components/pages/ComputerCare';
import Sensor from './components/pages/Sensor';
import Audio from './components/pages/Audio';
import Electricservices from './components/pages/Electricservices';
import AllAccessories from './components/pages/AllAccessories';
import SubmitReview from './components/pages/SubmitReview';


function App() {
  return (
    <Router>

      <div>



        <Routes>

          <Route axact path="/" element={<Home />} />
                <Route axact path="/contactus" element={<Contactus/>} />
                 <Route axact path="/Aboutus" element={<Aboutpage/>} />
                      <Route axact path="/our-projects" element={<Projectpage/>} />
                       <Route axact path="/product" element={<Productpage/>} />
                         <Route axact path="/cctv_camera" element={<Cctv/>} />
                          <Route axact path="/gps_system" element={<Gps/>} />
                          <Route axact path="/intercom-system" element={<Intercom/>} />
                            <Route axact path="/computer-care" element={<ComputerCare/>} />
                            <Route axact path="/sensor_system" element={<Sensor/>} />
                                <Route axact path="/audio-video" element={<Audio/>} />
                                   <Route axact path="/Electricservices" element={<Electricservices/>} />
                                   <Route axact path="/AllAccessories" element={<AllAccessories/>} />
                                   <Route axact path="/review" element={<SubmitReview/>} />
                                    
             </Routes>

        <Footer />
      </div>

    </Router>
  );
}

export default App;
